import React from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import i18next from "i18next";
import moment from "moment";
import { FormGroup, FormControl, FormLabel, } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import SubmitButton from "components/SubmitButton";
import InlineAlert from "components/InlineAlert";
import PlanFunctionsMultiSelect from "components/PlanFunctionsMultiSelect/PlanFunctionsMultiSelect";
import PlanEmployeesMultiSelect from "components/PlanEmployeesMultiSelect/PlanEmployeesMultiSelect";
// import * as groupsActions from "actions/groupsActions";
import { plansService } from "services";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es"; // datepicker locale
import "./PlanCopyModal.scss";
registerLocale("es", es);

class PlanCopy extends React.Component {
	constructor(props) {
		super(props);
		// console.log(props);

		const start = this.props.start;
		const end = this.props.end;
		const startDate = moment(start);
		const endDate = moment(end);
		const dayOfWeekNumeric = startDate.day(); // Obtener el día de la semana (0 = Domingo, 6 = Sábado)
		const minDate = endDate.add(1, 'days').toDate(); // Sumar un día
		const totalDays = endDate.diff(startDate, "days");


		this.state = {
			start,
			end,
			group: this.props.group,
			target_start: null,
			function_ids: [],
			employee_ids: [],
			isLoading: false,
			submitted: false,
			error_footer: "",
			errors: {},
			dayOfWeekNumeric,
			minDate,
			totalDays,
		};
	}

	handleFunctionsChange = (ids) => {
		const function_ids = Array.isArray(ids)
			? ids.map((id) => String(id)).filter((id) => id && id !== "-1")
			: [];

		this.setState({ function_ids });
	};

	handleEmployeesChange = (ids) => {
		const employee_ids = Array.isArray(ids)
			? ids.map((id) => String(id)).filter((id) => id && id !== "-1")
			: [];

		this.setState({ employee_ids });
	};

	_getFunctionIdsForApi = () => {
		return this.state.function_ids
			.map((id) => parseInt(id, 10))
			.filter((id) => !Number.isNaN(id) && id > 0);
	};

	_getEmployeeIdsForApi = () => {
		return this.state.employee_ids
			.map((id) => parseInt(id, 10))
			.filter((id) => !Number.isNaN(id) && id > 0);
	};

	handleDateChange = (id, date) => {
		let key = id;
		let value = date ? moment(date).format("YYYY-MM-DD") : null;

		this.setState({
			[key]: value,
		});
	};


	handleChange = (event) => {
		this.setState({
			[event.target.id]: event.target.value,
		});
	};

	checkValidField = (name) => {
		return (
			this.state.submitted &&
			this.state.errors[name] !== undefined &&
			this.state.errors[name] !== ""
		);
	};

	// copy plan
	handleSubmit = async (event) => {
		event.preventDefault();
		const { group, start, end, target_start, totalDays } = this.state;
		const props = this.props;
		const group_id = group.id;
		this.setState({ isLoading: true });

		const search_request = {
			page_size: 1000,
			start,
			end,
			group_id,
		};

		const function_ids = this._getFunctionIdsForApi();
		if (function_ids.length > 0) {
			search_request.function_ids = function_ids;
		}

		const employee_ids = this._getEmployeeIdsForApi();
		if (employee_ids.length > 0) {
			search_request.employee_ids = employee_ids;
		}

		const obj = {
			search_request,
			target_start,
		};
		// console.log(obj);
		const response = await plansService.copy(obj);

		if (response.ok) {
			toastr.success(i18next.t('common.success'), i18next.t('copyPlan.successMsg'));

			// cargar nuevo plan
			const targetStartDate = moment(target_start);
			const target_end = targetStartDate.add(totalDays - 1, "days").format("YYYY-MM-DD");

			const newURL = `/plans/${group_id}/${target_start}@${target_end}`;
			window.history.pushState(null, "", newURL);
			props.updateStateAndReload({ group_id, start: target_start, end: target_end });
			props.handleClose();
			this.setState({ isLoading: false });
		}
		else {
			// show error
			let error_footer = response.errors[0].description;
			// console.log(response.errors);

			this.setState({
				submitted: true,
				error_footer,
				isLoading: false
			});
		}

		// {
		// 	"status": 400,
		// 	"errors": [
		// 		{
		// 			"code": "not_valid",
		// 			"key": "planAssignmentFullCopy.holiday_or_absence_plans_not_allowed_for_copy",
		// 			"fields": [
		// 				"target_start"
		// 			],
		// 			"description": "El plan a copiar no debe tener ningún turno de ausencia o vacaciones planificado"
		// 		}
		// 	]
		// }
	};

	isWeekDayOK = (date) => {
		return date.getDay() === this.state.dayOfWeekNumeric; // Lunes (0 es domingo, 1 es lunes, etc.)
	};

	render() {
		const {
			target_start,
			minDate,
			totalDays,
			errors,
			error_footer,
			group,
			function_ids,
			employee_ids,
		} = this.state;
		const functions = this.props.functions || [];
		const employees = this.props.employees || [];

		return (
			<form onSubmit={this.handleSubmit} className="plan-copy-form">
				<div className="modal-body">
					<div className="plan-copy-summary">
						<div className="plan-copy-summary__item">
							<span className="plan-copy-summary__label">
								{i18next.t("copyPlan.labelGroup")}
							</span>
							<span className="plan-copy-summary__value">{group.name}</span>
						</div>
						<div className="plan-copy-summary__item">
							<span className="plan-copy-summary__label">
								{i18next.t("copyPlan.labelPeriod")}
							</span>
							<span className="plan-copy-summary__value">
								{totalDays} {i18next.t("copyPlan.unitDays")}
							</span>
						</div>
					</div>

					<FormGroup
						controlId="target_start"
						className={`form-group form-date ${target_start === "" && "empty"}  ${this.checkValidField("target_start") && "is-invalid"}`}
					>
						<FormLabel>
							{i18next.t("copyPlan.labelNewStart")}{" "}
							<span className="label-required">*</span>
						</FormLabel>

						<DatePicker
							selected={
								target_start === "" || !target_start
									? null
									: moment(target_start).toDate()
							}
							onChange={(date) => this.handleDateChange("target_start", date)}
							isInvalid={this.checkValidField("target_start")}
							className="form-control"
							dateFormat="dd/MM/yyyy"
							locale="es"
							placeholderText={i18next.t("copyPlan.datePlaceholder")}
							minDate={minDate}
							filterDate={this.isWeekDayOK}
						/>
						<FiCalendar />
						<p className="plan-copy-hint">
							{i18next.t("copyPlan.selectDateHint")}
						</p>
						<FormControl.Feedback type="invalid">
							{errors.target_start}
						</FormControl.Feedback>
					</FormGroup>

					{employees.length > 0 && (
						<FormGroup className="form-group">
							<FormLabel>{i18next.t("copyPlan.labelEmployees")}</FormLabel>
							<PlanEmployeesMultiSelect
								variant="panel"
								employees={employees}
								value={employee_ids}
								onChange={this.handleEmployeesChange}
								placeholder={i18next.t("copyPlan.employeesPlaceholder")}
								allLabel={i18next.t("copyPlan.employeesPlaceholder")}
								searchPlaceholder={i18next.t("copyPlan.searchEmployee")}
								clearLabel={i18next.t("plan.clearSelection")}
								noResultsLabel={i18next.t("copyPlan.noEmployeesFound")}
								selectedCountLabel={i18next.t("copyPlan.selectedCount")}
								hint={i18next.t("copyPlan.employeesHint")}
								controlId="copy_plan_employee_ids"
							/>
						</FormGroup>
					)}

					{functions.length > 0 && (
						<FormGroup className="form-group">
							<FormLabel>{i18next.t("copyPlan.labelFunctions")}</FormLabel>
							<PlanFunctionsMultiSelect
								variant="panel"
								functions={functions}
								value={function_ids}
								onChange={this.handleFunctionsChange}
								placeholder={i18next.t("copyPlan.functionsPlaceholder")}
								allLabel={i18next.t("plan.allFunctions")}
								searchPlaceholder={i18next.t("copyPlan.searchFunction")}
								clearLabel={i18next.t("plan.clearSelection")}
								noResultsLabel={i18next.t("plan.noFunctionsFound")}
								selectedCountLabel={i18next.t("copyPlan.selectedCount")}
								hint={i18next.t("copyPlan.functionsHint")}
								controlId="copy_plan_function_ids"
							/>
						</FormGroup>
					)}

					{this.state.error_footer && (
						<InlineAlert variant="error" className="mt15">
							{error_footer}
						</InlineAlert>
					)}
				</div>

				<div className="modal-footer">
					<button
						type="button"
						onClick={this.props.handleClose}
						className="btn btn-outline-primary"
					>
						{i18next.t('common.cancel')}
					</button>
					<SubmitButton
						type="submit"
						isLoading={this.state.isLoading}
						text={i18next.t('copyPlan.btnPaste')}
						loadingText={i18next.t('copyPlan.btnPasting')}
					/>
				</div>
			</form>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.groupsReducer,
		loading: reducers.groupsReducer.loading,
		user: reducers.authReducer.user,
	};
};


// const mapDispatchToProps = (dispatch) => ({
// 	getAllGroups: () =>
// 		dispatch(
// 			groupsActions.getAllGroups({ sort: "+name", variant: "detailed" })
// 		),
// });

export default connect(mapStateToProps, null)(PlanCopy);

